import React, { type Dispatch, type SetStateAction } from "react";

import { downloadDocumentById } from "../../../api";
import { LoadingIndicator, Modal } from "@synthesis/shared-ui";
import { convertBlobToBase64 } from "@synthesis/shared-utils";

interface AddModalPhotoPreview {
  id: string;
}

interface ModalPhotoPreviewProps extends AddModalPhotoPreview {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

type PhotoViewerProps = { id: string };
const PhotoViewer: React.FC<PhotoViewerProps> = React.memo(({ id }) => {
  const [src, setSrc] = React.useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      if (id) {
        try {
          const config: Parameters<typeof downloadDocumentById>[1] = { responseType: "blob" };
          const responseData = await downloadDocumentById(id, config);
          const base64Src = await convertBlobToBase64(responseData);
          setSrc(base64Src as string);
          setIsLoading(false);
        } catch {
          setIsLoading(false);
          setIsError(true);
        }
      }
    })();
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  if (isError) return <div>Не удалось загрузить изображение</div>;

  return (
    <div className="flex">
      <img className="h-auto w-full flex-1 object-contain" src={src} alt="Preview" />
    </div>
  );
});

const ModalPhotoPreview = React.memo((props: ModalPhotoPreviewProps) => {
  const { id } = props;
  return (
    <Modal.Root manual {...props}>
      <AddModalPhotoPreview id={id} />
    </Modal.Root>
  );
});

const AddModalPhotoPreview = React.memo(({ id }: AddModalPhotoPreview) => {
  return (
    <Modal.Content className="w-[35vw] min-w-[350px]">
      <Modal.Title>Просмотр изображения</Modal.Title>
      <PhotoViewer id={id} />
    </Modal.Content>
  );
});

export default ModalPhotoPreview;
